<template>
  <div class="contact-page d-flex flex-column min-vh-100">
    <!-- NAVBAR COMPONENT -->
    <NavbarView />

    <!-- CONTACT SECTION -->
    <section class="academy-contact py-5 text-center flex-grow-1">
      <div class="container">
        <h2 class="fw-bold mb-4">Contact Axion Science Academy</h2>
        <p>
          <i class="bi bi-geo-alt-fill me-2"></i>
          Address: 45 Knowledge Street, Science City, Sri Lanka
        </p>
        <p>
          <i class="bi bi-envelope-fill me-2"></i>
          Email: contact@axionscience.lk |
          <i class="bi bi-telephone-fill ms-2 me-1"></i>
          Phone: +94 77 123 4567 |
          <i class="bi bi-whatsapp ms-2 me-1"></i>
          <a
            href="https://wa.me/94771234567"
            target="_blank"
            class="text-pink text-decoration-none"
          >
            WhatsApp
          </a>
        </p>

        <div class="social-icons mt-3">
          <a href="#" class="text-pink fs-4 mx-2"
            ><i class="bi bi-facebook"></i
          ></a>
          <a href="#" class="text-pink fs-4 mx-2"
            ><i class="bi bi-twitter"></i
          ></a>
          <a href="#" class="text-pink fs-4 mx-2"
            ><i class="bi bi-linkedin"></i
          ></a>
          <a href="#" class="text-pink fs-4 mx-2"
            ><i class="bi bi-instagram"></i
          ></a>
        </div>
      </div>
    </section>

    <!-- FOOTER COMPONENT -->
    <FooterView />
  </div>
</template>

<script setup>
import NavbarView from "@/components/NavbarView.vue";
import FooterView from "@/components/FooterView.vue";
</script>

<style scoped>
.contact-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Full viewport height */
}

.academy-contact {
  flex-grow: 1; /* Fills the space between navbar and footer */
}

.academy-contact p {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.social-icons a {
  transition: 0.3s;
}

.social-icons a:hover {
  color: #ff00cc;
  text-shadow: 0 0 8px #ff00cc;
}

.text-pink {
  color: #ff00cc;
}

@media (max-width: 576px) {
  .academy-contact p {
    font-size: 0.95rem;
  }
  .social-icons a {
    font-size: 18px !important;
  }
}
</style>
